import { Box, Button, Card, CardActions, CardContent, Grid, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ComboCryptoCoins from "../ComboCryptoCoins";
import ComboNetwork from "../ComboNetwork";
import ComboAgentsByMerchant from "../ComboAgentsByMerchant";
import { getAgentDashboardBalances } from "../../actions/agent";
import { CryptoCurrencies } from "../../enums/CryptoCurrenciesCombo";
import { Networks } from "../../enums/networks";
import InputAmountMax from "../InputAmountMax";
import toast, { Toaster } from "react-hot-toast";
import { getDecimalsByCrypto } from "../../utils/cryptoCurrenciesUtils";
import { agentRequestTransfer } from "../../actions/transfer";

const styleButton = {
	backgroundColor: "#027af2",
	color: "#FFFFFF",
	height: "50px",
	width: "200px",
	textTransform: "capitalize",
	"&:hover": {
		color: "#FFFFFF",
		backgroundColor: "#003399",
	},
};

const CryptoSelectTransfer = ({ setCryptoCurrency, cryptoCurrency, setNetwork, network, title, setStep, token, agent, setAgent, setTransfer }) => {
	const [balances, setBalances] = useState(null);
	const [balance, setBalance] = useState(0);
	const [currency, setCurrency] = useState("USD");
	const [exchangeRate, setExchangeRate] = useState(0);
	const [maxSet, setMaxSet] = useState(false);
	const [amount, setAmount] = useState(null);

	const nextStep = (e) => {
		if (amount > 0 && agent !== null) {
			const exchange = getExchangeByCrypto(cryptoCurrency);
			let tempAmount = 0;
			if (currency === "USD") {
				if (maxSet) {
					tempAmount = balance;
				} else {
					tempAmount = parseFloat(parseFloat(amount / exchange).toFixed(getDecimalsByCrypto(cryptoCurrency)));
				}
			} else {
				tempAmount = parseFloat(parseFloat(amount).toFixed(getDecimalsByCrypto(cryptoCurrency)));
			}

			if (parseFloat(tempAmount) > parseFloat(balance)) {
				toast.error(`Amount is greater than balance`);
			} else if (tempAmount <= 0) {
				toast.error(`Amount must be greater than cero`);
			} else {
				if (agent) {
					agentRequestTransfer(token, cryptoCurrency, network, agent, tempAmount, currency, maxSet, (res) => {
						if (res.error === true) {
							toast.error(res.message);
						} else {
							setTransfer(res.data);
							setStep(2);
						}
					});
				} else {
					toast.error(`Insert a valid address`);
				}
			}
		} else {
			toast.error(`Invalid info please review.`);
		}
	};

	const getExchangeByCrypto = () => {
		let exch = 0;
		switch (cryptoCurrency) {
			case CryptoCurrencies.BITCOIN:
				exch = balances?.exchangeRate?.exchangeRateBTC ?? 0;
				break;
			case CryptoCurrencies.ETHEREUM:
				exch = balances?.exchangeRate?.exchangeRateETH ?? 0;
				break;
			case CryptoCurrencies.USDT:
				exch = balances?.exchangeRate?.exchangeRateUSDT ?? 0;
				break;
			case CryptoCurrencies.USDC:
				exch = balances?.exchangeRate?.exchangeRateUSDC ?? 0;
				break;
			case CryptoCurrencies.TRX:
				exch = balances?.exchangeRate?.exchangeRateTRX ?? 0;
				break;
			case CryptoCurrencies.LITECOIN:
				exch = balances?.exchangeRate?.exchangeRateLTC ?? 0;
				break;
			case CryptoCurrencies.DOGECOIN:
				exch = balances?.exchangeRate?.exchangeRateDOGE ?? 0;
				break;
			case CryptoCurrencies.XRP:
				exch = balances?.exchangeRate?.exchangeRateXRP ?? 0;
				break;
			default:
				exch = 0;
				break;
		}
		setExchangeRate(exch);
		return exch;
	};

	useEffect(() => {
		getAgentDashboardBalances(token, "", (data) => {
			if (!data.error) {
				setBalances(data.data);				
				getExchangeByCrypto();
				switch (cryptoCurrency) {
					case CryptoCurrencies.BITCOIN:
						setBalance(data.data.balances.balanceBTC);
						break;
					case CryptoCurrencies.ETHEREUM:
						if (network === Networks.ETHEREUM) {
							setBalance(data.data.balances.balanceETH);
						} else if (network === Networks.BASE) {
							setBalance(data.data.balances.balanceETHBASE);
						}
						break;
					case CryptoCurrencies.USDT:
						if (network === Networks.ETHEREUM) {
							setBalance(data.data.balances.balanceUSDT);
						} else if (network === Networks.TRON) {
							setBalance(data.data.balances.balanceUSDTTRON);
						}
						break;
					case CryptoCurrencies.USDC:
						if (network === Networks.ETHEREUM) {
							setBalance(data.data.balances.balanceUSDC);
						} else if (network === Networks.BASE) {
							setBalance(data.data.balances.balanceUSDCBASE);
						}
						break;
					case CryptoCurrencies.LITECOIN:
						setBalance(data.data.balances.balanceLTC);
						break;
					case CryptoCurrencies.DOGECOIN:
						setBalance(data.data.balances.balanceDOGE);
						break;
					case CryptoCurrencies.XRP:
						setBalance(data.data.balances.balanceXRP);
						break;
					case CryptoCurrencies.TRX:
						setBalance(data.data.balances.balanceTRX);
						break;
					default:
						break;
				}				
			}
		});
	}, [network,balance]);

	/*useEffect(() => {
		if (balances) {
			getExchangeByCrypto();
			switch (cryptoCurrency) {
				case CryptoCurrencies.BITCOIN:
					setBalance(balances.balances.balanceBTC);
					break;
				case CryptoCurrencies.ETHEREUM:
					if (network === Networks.ETHEREUM) {
						setBalance(balances.balances.balanceETH);
					} else if (network === Networks.BASE) {
						setBalance(balances.balances.balanceETHBASE);
					}
					break;
				case CryptoCurrencies.USDT:
					if (network === Networks.ETHEREUM) {
						setBalance(balances.balances.balanceUSDT);
					} else if (network === Networks.TRON) {
						setBalance(balances.balances.balanceUSDTTRON);
					}
					break;
				case CryptoCurrencies.USDC:
					if (network === Networks.ETHEREUM) {
						setBalance(balances.balances.balanceUSDC);
					} else if (network === Networks.BASE) {
						setBalance(balances.balances.balanceUSDCBASE);
					}
					break;
				case CryptoCurrencies.LITECOIN:
					setBalance(balances.balances.balanceLTC);
					break;
				case CryptoCurrencies.DOGECOIN:
					setBalance(balances.balances.balanceDOGE);
					break;
				case CryptoCurrencies.XRP:
					setBalance(balances.balances.balanceXRP);
					break;
				case CryptoCurrencies.TRX:
					setBalance(balances.balances.balanceTRX);
					break;
				default:
					break;
			}
		}
	}, [network]);*/

	let isMobile = false;

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		isMobile = true;
	}

	return (
		<Grid sx={{ width: isMobile ? "100%" : 500 }}>
			<Card>
				<CardContent>
					<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
						{title}
					</Typography>
					<ComboCryptoCoins
						setCryptoCurrency={setCryptoCurrency}
						cryptoCurrency={cryptoCurrency}
						setNetwork={setNetwork}
						token={token}
						setAmount={setAmount}
					/>
					<ComboNetwork setNetwork={setNetwork} network={network} cryptoCurrency={cryptoCurrency} />
					<ComboAgentsByMerchant token={token} setAgent={setAgent} agent={agent} />
					<InputAmountMax
						setAmount={setAmount}
						balance={balance}
						cryptoCurrency={cryptoCurrency}
						network={network}
						currency={currency}
						setCurrency={setCurrency}
						balances={balances}
						setMaxSet={setMaxSet}
					/>
					<Box sx={{ padding: 0, margin: 0 }}>
						<Table sx={{ padding: 0, margin: 0 }}>
							<TableBody>
								<TableRow sx={{ padding: 0, margin: 0 }}>
									<TableCell sx={{ textAlign: "left", padding: 0, margin: 0 }}>{`Balance`}</TableCell>
									<TableCell sx={{ textAlign: "right", padding: 0, margin: 0 }}>{`${balance??0} ${cryptoCurrency ?? ""}`}</TableCell>
								</TableRow>
								<TableRow sx={{ padding: 0, margin: 0 }}>
									<TableCell sx={{ textAlign: "left", padding: 0, margin: 0 }}>{`Exchange Rate`}</TableCell>
									<TableCell sx={{ textAlign: "right", padding: 0, margin: 0 }}>{`$${exchangeRate??0}`}</TableCell>
								</TableRow>
								<TableRow sx={{ padding: 0, margin: 0 }}>
									<TableCell sx={{ textAlign: "left", padding: 0, margin: 0 }}>{`Balance USD`}</TableCell>
									<TableCell sx={{ textAlign: "right", padding: 0, margin: 0 }}>{`$${parseFloat(balance??0 * exchangeRate).toFixed(
										2
									)}`}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</Box>
					<Toaster />
				</CardContent>
				<CardActions>
					<Box sx={{ alignItems: "center", alignContent: "center", textAlign: "center", width: "100%", paddingBottom: 4, paddingTop: 2 }}>
						<Button size="large" variant="extended" sx={styleButton} onClick={nextStep} disabled={network === null && amount === null}>
							TRANSFER
						</Button>
					</Box>
				</CardActions>
			</Card>
		</Grid>
	);
};

export default CryptoSelectTransfer;
